export default {
      id: "LWS-3px-usage",
      viewBox: "0 0 60 3",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-3px",
      toString: function () {
        return this.url;
      }
    }